export default __webpack_public_path__ + "d3fec98595dfc99eb95f0d6345bad38e.svg";